import { StyleFn } from '..'

export const Progressbar: StyleFn = ({ color, font, size }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  percentage: {
    width: size.spacing[40],
    lineHeight: size.spacing[24],
    marginRight: size.spacing[8],
    textAlign: 'right',
    fontSize: font.size.small,
    color: color.palette.coolgrey[90],
    '&$percentage_right': {
      marginRight: 0,
      marginLeft: size.spacing[8],
      textAlign: 'left',
    },
  },
  percentage_right: {},
  track: {
    height: size.spacing[8],
    width: '100%',
    overflow: 'hidden',
    position: 'relative',
    borderRadius: size.spacing[4],
    backgroundColor: color.palette.warmgrey[30],
  },
  fill: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    borderRadius: size.spacing[4],
    backgroundColor: color.palette.primaryblue[50],
    transition: 'width 1s',
  },
  label: {
    fontSize: font.size.small,
    fontWeight: font.weight.medium,
    color: color.palette.primaryblue[100],
  },
  _indeterminate: {
    '& $fill': {
      width: '50%',
      left: '-50%',
      animation: '$indeterminate 1.5s linear infinite',
    },
  },
  _success: {
    '& $fill': {
      backgroundColor: color.background.interactive.success.default,
    },
  },
  _warning: {
    '& $fill': {
      backgroundColor: color.background.interactive.warning.default,
    },
  },
  _error: {
    '& $fill': {
      backgroundColor: color.background.interactive.error.default,
    },
  },
  '@keyframes indeterminate': {
    from: {
      transform: 'translateX(0)',
    },
    to: {
      transform: 'translateX(400%)',
    },
  },
})
